export enum AppActions {
  LOAD_STATE_REQUEST = '[Application] LOAD_STATE_REQUEST',
  LOAD_STATE_SUCCESS = '[Application] LOAD_STATE_SUCCESS',
  LOAD_STATE_FAILURE = '[Application] LOAD_STATE_FAILURE',

  SAVE_STATE_SUCCESS = '[Application] SAVE_STATE_SUCCESS',
  SAVE_STATE_FAILURE = '[Application] SAVE_STATE_FAILURE',
}
